import { AbstractIconComponent } from './abstract.icon'
import { Component, Input } from '@angular/core'

@Component({
  selector: 'icon-close',
  templateUrl: './close.icon.html',
})
export class CloseIconComponent extends AbstractIconComponent {
  static icon = 'close'
  @Input() color = '#d81e05'
}
